import { DesktopHeader } from './DesktopHeader'
import type { HeaderProps } from './Header.Types'
import { MobileHeader } from './MobileHeader'

const Header = ({
  headerImages,
  headline,
  subheadline,
  button,
  shouldShowRating,
}: HeaderProps) => {
  return (
    <section id={'hero'}>
      <MobileHeader
        headerImages={headerImages}
        headline={headline}
        subheadline={subheadline}
        button={button}
        shouldShowRating={shouldShowRating}
      />
      <DesktopHeader
        headerImages={headerImages}
        headline={headline}
        subheadline={subheadline}
        button={button}
        shouldShowRating={shouldShowRating}
      />
    </section>
  )
}

export default Header
